import { useEffect, useRef } from 'react';
import { useStore } from '~/stores';
import { usePlatform } from '~/services/platform';

/**
 * Hook to initialize platform-dependent values (deviceId, deviceInfo) in authStore.
 * Should be called once at app root level, BEFORE useSyncInit.
 *
 * This ensures deviceId is available even when VITE_REQUIRE_ACTIVATION=false
 * and the user navigates directly to Stream without going through Auth.
 */
export const usePlatformInit = () => {
  const { authStore } = useStore();
  const platform = usePlatform();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    // Initialize device identification (non-blocking)
    authStore.initializeDeviceId(platform);
  }, [authStore, platform]);
};

export default usePlatformInit;
